export enum Method {
  AUTH = 'auth',
  GET = 'get',
  POST = 'post',
  PUT = 'put',
  PATCH = 'patch',
  DELETE = 'delete',
  ERROR = 'error'
}